import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../utils/csrf"

// The Lip-sync video block's buttons (shared/_lipsync_block): turn the video
// on or off with a PATCH and draw the turbo stream that comes back. Buttons,
// not forms - the block sits inside the Ask me editor's own form.
export default class extends Controller {
  static values = { url: String }

  async toggle(event) {
    event.preventDefault()
    const button = event.currentTarget
    button.disabled = true
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Accept: "text/vnd.turbo-stream.html", "X-CSRF-Token": csrfToken() },
        body: JSON.stringify({ on: button.dataset.on })
      })
      if (!response.ok) throw new Error()
      window.Turbo.renderStreamMessage(await response.text())
    } catch (_error) {
      button.disabled = false
    }
  }
}
